<!--
    我的课程-单个课程组件
    功能：单个课程组件内容
    说明：版本3.0
-->
<template>
  <div
    class="package-item"
    @click="gotoDetail(item.id)">
    <div class="cont">
      <div
        v-if="item.auth_expire_time"
        class="limit cover-txt">
        <div class="txt">截止有效期</div>
        <div class="txt">{{ item.auth_expire_time }}</div>
      </div>
      <div
        v-else
        class="surplus cover-txt">
        <div class="txt">剩余{{ item.auth_number - item.used_number }}次</div>
      </div>
      <img
        :src="item.packet.cover?item.packet.cover:$assets.classDefault"
        class="item-bg">
    </div>
    <div class="title elps">{{ item.packet.name }}</div>
  </div>
</template>
<script>
export default {
  name: 'PackageItem',
  props: {
    item: Object,
  },
  data() {
    return {
    };
  },
  methods: {
    gotoDetail(id) {
      this.$router.push(`/packageList/packageDetail?packetAuthId=${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.package-item{
    width: 165px;
    cursor: pointer;
    &:hover{
      .item-bg{
        transform: scale(1.2);
        transition: .4s all ease;
      }
      .title{
        color: #FF7838;
      }
    }
    .cont{
        width: 165px;
        height: 184px;
        border:1px solid #eee;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        .item-bg{
         width: 100%;
         height: 100%;
         object-fit: cover;
         border-radius: 4px;
        }
        .cover-txt{
            position: absolute;
            left: 10px;
            bottom: 10px;
            color: #fff;
            border-radius: 4px;
            font-size: 12px;
             padding: 5px 8px;
            background-color: rgba($color: #000000, $alpha: .5);
            z-index: 999;
            &.lock{
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
            }
            .txt{
              line-height: 20px;
            }
        }
    }
    .title{
        color: #303133;
        font-size: 15px;
        line-height: 44px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageList/components/packageItem.vue